(ns machtfit.startpage.filter
  (:require [clojure.set :as set]
            [machtfit.repository.products :as products]
            [machtfit.repository.search-facets :as search-facets]
            [machtfit.startpage.statics :as statics]
            [medley.core :refer [map-vals update-existing]]))

(def default-filter
  {:distance 70
   :online true
   :area :all
   :categories #{}
   :gender #{}
   :age #{}
   :labels #{}
   :days #{}
   :weekdays #{}
   :times #{}
   :no-schedule false
   :keyword ""
   :price-max nil
   :price-min nil
   :starts-after "00:00"
   :starts-before "23:59"
   :favorites false

   ; these five are price filters, the defaults have to be here,
   ; otherwise the "false" value will be added to the GET parameters
   :free-of-charge? false
   :estg3no34-subsidizable? false
   :mf-offer false
   :promotions false
   :subsidy false})

(defn cleaned-filter-presets [non-empty-categories]
  (let [clean-filter (fn [{{:keys [area]} :filter :as preset}]
                       (update preset :filter #(update-existing % :categories set/intersection (area non-empty-categories #{}))))]
    (map-vals clean-filter statics/filter-presets)))

(defn filter-preset->filter [filter-preset non-empty-categories user-labels]
  (cond-> {}
    filter-preset (merge (:filter (filter-preset (cleaned-filter-presets non-empty-categories))))
    (= filter-preset :recommendations) (assoc :labels user-labels)))

(defn effective-filter [filter-preset custom-filter non-empty-categories user-labels]
  (merge default-filter
         (filter-preset->filter filter-preset non-empty-categories user-labels)
         custom-filter))

(defn db->effective-filter [db non-empty-categories]
  (effective-filter (-> db :ui :filter-preset) (:filter db) non-empty-categories (-> db :user :labels)))

(defn db->non-empty-categories [db]
  ;; Server-decided facets when they have landed — on that path the catalogue is
  ;; never fetched, so deriving them from it would yield nothing. The endpoint
  ;; answers empty lists for a caller it cannot scope, which is not "landed".
  (if-let [by-area (not-empty
                    (into {} (remove (comp empty? val))
                          (:categories-by-area (search-facets/facets db))))]
    {:machtfit (set (:machtfit by-area))
     :company (set (:company by-area))}
    (->> db products/from-db vals (group-by :area) (map-vals #(->> % (map :category) set)))))

(defn apply-filter-event [db change-filter filter-preset]
  (let [non-empty-categories (db->non-empty-categories db)
        new-effective-filter-set (-> db (db->effective-filter non-empty-categories) change-filter set)
        user-labels (-> db :user :labels)
        new-filter-preset-filter (filter-preset->filter filter-preset non-empty-categories user-labels)
        new-custom-filter-set (-> new-effective-filter-set
                                  (set/union (set new-filter-preset-filter))
                                  (set/difference (set default-filter)))
        new-custom-filter (into {} new-custom-filter-set)]
    (-> db
        (assoc-in [:tracking :previous-user-filter] (get db :filter))
        (assoc :filter new-custom-filter)
        (update :ui assoc
                :keyword (:keyword new-custom-filter)
                :show-products (or (-> db :ui :show-products) 28)))))
